import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { LayoutTemplate, ArrowRight } from "lucide-react";

const ACCENT = {
  emerald: "text-emerald-400 border-emerald-500/30", cyan: "text-cyan-400 border-cyan-500/30",
  indigo: "text-indigo-400 border-indigo-500/30", amber: "text-amber-400 border-amber-500/30",
  rose: "text-rose-400 border-rose-500/30",
};

export default function Templates() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => { api.get("/templates").then((r) => setTemplates(r.data)).catch(() => {}); }, []);

  const use = async (t) => {
    setBusy(t.id);
    try {
      const { data } = await api.post("/projects", { prompt: t.prompt, name: t.name });
      navigate(`/workspace/${data.id}`, { state: { autoRun: t.prompt } });
    } catch (e) { toast.error("Could not start template"); setBusy(null); }
  };

  return (
    <div className="space-y-6" data-testid="templates-page">
      <div>
        <h1 className="text-2xl font-head font-bold">Templates</h1>
        <p className="text-slate-400 mt-1">Start from a proven prompt. Agents build the full app for you.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map((t) => (
          <div key={t.id} data-testid={`template-${t.id}`} className="rounded-2xl border border-slate-800 bg-slate-900/40 p-5 flex flex-col">
            <div className={`h-10 w-10 rounded-xl border bg-slate-800/60 flex items-center justify-center mb-4 ${ACCENT[t.accent] || ACCENT.emerald}`}>
              <LayoutTemplate className="h-5 w-5" />
            </div>
            <div className="text-xs text-slate-500 uppercase tracking-wider mb-1">{t.category}</div>
            <h3 className="font-head font-semibold text-lg">{t.name}</h3>
            <p className="text-sm text-slate-400 mt-1 flex-1">{t.desc}</p>
            <button data-testid={`use-template-${t.id}`} disabled={busy === t.id} onClick={() => use(t)}
              className="mt-4 h-10 rounded-xl border border-slate-700 hover:border-emerald-500/50 hover:text-emerald-400 text-sm font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
              {busy === t.id ? "Starting..." : <>Use template <ArrowRight className="h-4 w-4" /></>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
